import config from 'config/default';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useVisibilityTracker } from './use-visibility-tracker';

const useLinkedinCookies = () => {
  const extensionIdChrome = config.extensionIdChrome;
  const extensionIdEdge = config.extensionIdEdge;

  const { tabActive } = useVisibilityTracker();

  const [liAtCookie, setLiAtCookie] = useState<string>('');
  const [sessionCookie, setSessionCookie] = useState<string>('');
  const [seatCookie, setSeatCookie] = useState<string>('');

  const fetchCookiesFromLinkedin = () => {
    const responseCallback = (response: any) => {
      if (chrome?.runtime?.lastError) {
        return;
      }

      if (!_.isNil(response) && response.action === 'linkedin-cookies') {
        const liAt = response.body.liAt;
        const jSessionId = response.body.jSessionId;
        const liA = response.body.liA;

        if (!_.isNil(liAt) && !_.isNil(jSessionId)) {
          setLiAtCookie(liAt.value);
          setSessionCookie(jSessionId.value);
        }

        if (!_.isNil(liA)) {
          setSeatCookie(liA.value);
        }
      }
    };

    try {
      chrome?.runtime?.sendMessage(extensionIdChrome, { action: 'get-linkedin-cookies' }, responseCallback);
      chrome?.runtime?.sendMessage(extensionIdEdge, { action: 'get-linkedin-cookies' }, responseCallback);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchCookiesFromLinkedin();
  }, [tabActive]);

  return {
    liAtCookie,
    sessionCookie,
    seatCookie,
  };
};

export default useLinkedinCookies;
